import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'environments/environment';

import { FeatureFlag } from '../constants/feature-flags.constant';
import { RoutePath } from '../enums/route-path.enum';

export function featureFlagGuard(flag: FeatureFlag): CanActivateFn {
  return () => {
    const router = inject(Router);

    if (!environment.featureFlags?.[flag]) {
      return router.createUrlTree([RoutePath.NotFound]);
    }

    return true;
  };
}
